import SlimSelect from 'slim-select';

document.addEventListener('DOMContentLoaded', () => {
    
    // Init SlimSelect
    const selects = document.querySelectorAll('.contact-form__select');
    if (selects.length > 0) {
        selects.forEach(select => {
            new SlimSelect({
                select: select,
                settings: {
                    showSearch: false,
                    openPosition: 'relative'
                }
            });
        });
    }

    // Drag & Drop for file
    const dropzones = document.querySelectorAll('.js-dropzone');

    dropzones.forEach(dropzone => {
        const fileInput = dropzone.querySelector('.js-file-input');
        const fileNameDisplay = dropzone.querySelector('.js-file-name');

        ['dragenter', 'dragover', 'dragleave', 'drop'].forEach(eventName => {
            dropzone.addEventListener(eventName, preventDefaults, false);
        });

        function preventDefaults(e) {
            e.preventDefault();
            e.stopPropagation();
        }

        // Add/remove class when hovering over file
        ['dragenter', 'dragover'].forEach(eventName => {
            dropzone.addEventListener(eventName, () => {
                dropzone.classList.add('is-dragover');
            }, false);
        });

        ['dragleave', 'drop'].forEach(eventName => {
            dropzone.addEventListener(eventName, () => {
                dropzone.classList.remove('is-dragover');
            }, false);
        });

        // Handle the Drop event (when the file is dropped)
        dropzone.addEventListener('drop', (e) => {
            const dt = e.dataTransfer;
            const files = dt.files;
            
            if (files && files.length > 0) {
                handleFiles(files[0], fileInput, fileNameDisplay);
            }
        });

        // Handling the Change event (when a file is clicked and selected in a standard window)
        fileInput?.addEventListener('change', function () {
            if (this.files && this.files.length > 0) {
                handleFiles(this.files[0], fileInput, fileNameDisplay);
            }
        });
    });

    // File validation and assignment function
    function handleFiles(file, inputElement, displayElement) {
        // Ceck size (5MB = 5 * 1024 * 1024 байт)
        const maxSize = 5 * 1024 * 1024;
        const allowedTypes = [
            'application/pdf', 
            'application/msword', 
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
        ];

        if (file.size > maxSize) {
            alert('File is too large. Maximum size is 5MB.');
            inputElement.value = ''; // Clear
            displayElement.textContent = '';
            return;
        }

        if (!allowedTypes.includes(file.type)) {
            alert('Invalid file format. Please upload PDF, DOC, or DOCX.');
            if (inputElement) {
                inputElement.value = ''; // Clear
            }

            if (displayElement) {
                displayElement.textContent = '';
            }
        
            return;
        }

        const dataTransfer = new DataTransfer();
        dataTransfer.items.add(file);

        if (inputElement) {
            inputElement.files = dataTransfer.files;
        }

        displayElement.textContent = file.name;
    }

    // Input Radio 

    const radioGroups = document.querySelectorAll('.contact-form__row--rating .wpcf7-radio');

    radioGroups.forEach(group => {
        const items = group.querySelectorAll('.wpcf7-list-item');
        
        const updateRating = () => {
            let foundChecked = false;

            items.forEach((item) => {
                const input = item.querySelector('input');
                item.classList.add('is-active'); 
                
                if (input.checked) {
                    foundChecked = true;
                }
                
                if (foundChecked === false) {
                    // If we haven't reached the selected one, we leave it active
                } else {
                    if (!input.checked) {
                        item.classList.remove('is-active');
                    }
                }
            });
        };

        items.forEach(item => {
            item.addEventListener('click', function(e) {
                const input = this.querySelector('input');
                if (input) {
                    input.checked = true;
                    input.dispatchEvent(new Event('change', { bubbles: true }));
                    updateRating();
                }
            });
        });

        group.addEventListener('change', updateRating);
        
        updateRating();
    });
});